// @spec SCF-004
// @spec SCF-008
// @spec IAM-STR-001
// @spec SHL-STR-003
// @spec SHL-STR-015
// @spec SHL-STR-016
// @spec SHL-STR-039
// @spec SHL-STR-040
// ClerkProvider moved to providers.tsx to wrap InnerApp before router initialization
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

import { NotFound } from '@/components/not-found';
import { OfflineBanner } from '@/components/offline';
import { GlobalSearch } from '@/components/search';
import { ServerError } from '@/components/server-error';
import { ThemeProvider } from '@/components/theme-provider';
import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { useGlobalSearch } from '@/hooks/use-global-search';
import type { RouterContext } from '@/types/router';

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: NotFound,
  errorComponent: ({ error }) => <ServerError error={error} />,
});

function RootLayout() {
  const { isOpen, closeSearch } = useGlobalSearch();

  return (
    <ThemeProvider defaultTheme="system" storageKey="quantifier-theme">
      <TooltipProvider delayDuration={300}>
        <OfflineBanner />
        <div className="min-h-screen bg-background text-foreground">
          <Outlet />
        </div>
        <Toaster />
        <GlobalSearch
          open={isOpen}
          onOpenChange={(open) => {
            if (!open) closeSearch();
          }}
        />
      </TooltipProvider>
    </ThemeProvider>
  );
}
